import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import PageContainer from './PageContainer';
import LifePreserverIcon from '../icons/LifePreserverIcon';
import HelpPageCards from '../organisms/HelpPageCards';
import { COLOR_BACKGROUND_LIGHT } from '../styles/colors';

const useStyles = makeStyles(theme => ({
  helpPageTemplate: {
    minHeight: '100vh',
  },

  paper: {
    width: '100%',
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    margin: 0,
    padding: theme.spacing(2),
    backgroundColor: COLOR_BACKGROUND_LIGHT,
    ...theme.typography.h1,
    fontWeight: 700,

    [theme.breakpoints.up('md')]: {
      minHeight: '200px',
      padding: theme.spacing(5),
    },

    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(10),
    }
  },

  headerIcon: {
    width: '58px',
    height: '58px',
    marginRight: theme.spacing(3),

    [theme.breakpoints.up('sm')]: {
      marginRight: theme.spacing(5),
    },
  },
}), { name: HelpPageTemplate.name });

export default function HelpPageTemplate () {
  const classes = useStyles();

  return (
    <PageContainer className={classes.helpPageTemplate}>
      <Paper className={classes.paper}>
        <h1 className={classes.header}>
          <LifePreserverIcon className={classes.headerIcon} />
          Help Center
        </h1>

        <HelpPageCards />
      </Paper>
    </PageContainer>
  );
}
